// extracted by mini-css-extract-plugin
export var dataCell = "_rd-2";
export var dataRow = "_rd-0";
export var headerRow = "_rd-1";